import { O as i } from "./country-5727f554.js";
import { i as l } from "./lib-e67158cc.js";
const I = "authorized_twitter_callback", g = "authorized_line_callback", _ = "twitter_owner_auth", E = "twitter_auth", u = "line_auth", p = "fb_auth", w = "apple_auth", d = "google_auth", f = "2004247419", L = (t, r) => {
  if (n)
    throw new Error("setLocalItem is not support in server");
  typeof r == "object" ? localStorage.setItem(t, JSON.stringify(r)) : localStorage.setItem(t, r);
}, T = (t) => {
  if (n)
    throw new Error("getLocalItem is not support in server");
  const r = localStorage.getItem(t);
  if (!r)
    return null;
  try {
    return JSON.parse(r);
  } catch {
    return r;
  }
}, b = (t, r = 600) => {
  if (n)
    throw new Error("getLocalItemWithExpires is not support in server");
  const e = T(t);
  try {
    return e != null && e.t && (e == null ? void 0 : e.t) + r * 1e3 < Date.now() ? (s(t), null) : e;
  } catch {
    return e;
  }
}, s = (t) => {
  if (n)
    throw new Error("removeLocalItem is not support in server");
  localStorage.removeItem(t);
}, A = () => {
  if (n)
    throw new Error("clearLocalItem is not support in server");
  s(E), s(u), s(_), s(w), s(d), s(p);
}, S = {
  SUCCESS: "success",
  CANCEL: "cancel",
  ERROR: "error"
}, N = {
  TWITTER: "x",
  LINE: "line",
  FB: "fb",
  GOOGLE: "google",
  APPLE: "apple"
}, n = typeof window > "u", O = ({ url: t, name: r, width: e = 600, height: o = 630 }) => {
  const a = (window.innerHeight - e) / 2 + window.screenY, c = (window.innerWidth - o) / 2 + window.screenX;
  return l ? (window.location.href = t, window) : window.open(
    t,
    r,
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, dialog=yes,top=${a}px,left=${c},width=${e}px,height=${o}px`
  );
}, U = ({ popup: t, interval: r, onClose: e }) => {
  const o = setInterval(() => {
    t.closed && (clearInterval(o), e());
  }, r || 100);
}, H = (t) => {
  const r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let e = "";
  for (let o = 0; o < t; o++)
    e += r.charAt(
      Math.floor(Math.random() * r.length)
    );
  return e;
}, R = () => 1, W = () => 1, v = (t) => `${`${i("BOSSJOB_JOBSEEKER_ENDPOINT")}/handlers/social-auth-redirect`}?redirect_uri=${t}`;
export {
  w as A,
  p as F,
  d as G,
  u as L,
  N as S,
  E as T,
  b as a,
  g as b,
  H as c,
  f as d,
  S as e,
  A as f,
  v as g,
  U as h,
  W as i,
  I as j,
  R as k,
  _ as l,
  n as m,
  O as o,
  s as r,
  L as s
};
//# sourceMappingURL=helper-513a9c5f.js.map
